module.exports = __webpack_public_path__ + "img/img-2.ea16a700.jpg";